const hqQueryKey = {
  getBranches: (hqId: number) => ['hq', hqId, 'branches'],
}

export default hqQueryKey
